import React, { Component } from 'react'
import moment from 'moment'
import { Query, graphql, compose } from 'react-apollo'
import { toast } from 'react-toastify'
import SweetAlert from 'sweetalert-react'

import cliente from 'graphql/queries/cliente'
import clientiById from 'graphql/queries/clientiById'
import deleteCliente from 'graphql/mutations/deleteCliente'
import accorpaClienti from 'graphql/mutations/accorpaClienti'
import inviaAdAffitti from 'graphql/mutations/inviaAdAffitti'

import GridContainer from 'components/Grid/GridContainer.jsx'
import ItemGrid from 'components/Grid/ItemGrid.jsx'
import { PortalIndicators, getPortalsFromInterests } from 'components/Portal/Portal.jsx'
import Button from 'material-ui/Button'
import TextField from 'material-ui/TextField'

import FormCliente from './FormCliente'
import FormCreaAzione from './FormCreaAzione'
import DropzoneAllegato from './DropzoneAllegato'

import 'sweetalert/dist/sweetalert.css'
import './Dati.css'

const CloseButton = ({ closeToast }) => {
  return (
    <a
      href="#"
      style={{ lineHeight: 1, fontSize: '20px', color: 'rgba(255, 255, 255, 0.7)', fontWeight: 700, display: 'table', padding: '0 5px' }}
      onClick={() => closeToast()}
    >
      &times;
    </a>
  )
}

class Dati extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showDeleteAlert: false,
      showSendAlert: false,
      clienteId: '',
      stepAccorpamento: 1
    }
  }

  openDeleteAlert = () => {
    this.setState({
      showDeleteAlert: true
    })
  }

  closeDeleteAlert = () => {
    this.setState({
      showDeleteAlert: false
    })
  }

  openSendAlert = () => {
    this.setState({
      showSendAlert: true
    })
  }

  closeSendAlert = () => {
    this.setState({
      showSendAlert: false
    })
  }

  handleSaved = () => {
    // this.props.history.push('/clienti')
    toast.success("Modifiche salvate correttamente", {
      closeButton: <CloseButton />
    })
  }

  handleActionCreated = () => {
    toast.success("Telefonata salvata correttamente", {
      closeButton: <CloseButton />
    })
  }

  handleFileSaved = () => {
    toast.success("Allegato caricato correttamente", {
      closeButton: <CloseButton />
    })
  }

  handleDeleted = (id, nome) => event => {
    this.props.deleteCliente({
      variables: {
        id
      },
    })
    .then(() => {
      this.closeDeleteAlert()
      this.props.history.push('/clienti')
      toast.success(`Cliente ${nome} eliminato correttamente`, {
        closeButton: <CloseButton />
      })
    })
    .catch(error => {
      console.log(error.message)
      toast.error(`È avvenuto un errore durante l'eliminazione del cliente ${nome}`, {
        closeButton: <CloseButton />
      })
    })
  }

  handleSent = (id, nome) => event => {
    this.props.inviaAdAffitti({
      variables: {
        clienteId: id
      },
      refetchQueries: [
        {
          query: cliente,
          variables: {
            where: {
              id
            }
          }
        }
      ]
    })
    .then(() => {
      this.closeSendAlert()
      toast.success(`Cliente ${nome} inviato correttamente ad affittimoderni.it`, {
        closeButton: <CloseButton />
      })
    })
    .catch(error => {
      console.log(error.message)
      toast.error(`È avvenuto un errore durante l'invio del cliente ${nome} ad affittimoderni.it`, {
        closeButton: <CloseButton />
      })
    })
  }

  handleChangeClienteId = event => {
    this.setState({
      clienteId: event.target.value
    })
  }

  handleCercaClienteDaAccorpare = () => {
    this.setState({
      stepAccorpamento: 2
    })
  }

  handleRiprovaAccorpamento = () => {
    this.setState({
      stepAccorpamento: 1
    })
  }

  handleConfermaAccorpamento = (idPrincipale, idDaAccorpare) => event => {
    event.preventDefault()

    this.props.accorpaClienti({
      variables: {
        clienteIdPrincipale: parseInt(idPrincipale, 10),
        clienteIdDaAccorpare: parseInt(idDaAccorpare, 10)
      },
      refetchQueries: [
        {
          query: clientiById,
          variables: {
            id: parseInt(this.state.clienteId, 10)
          }
        }
      ]
    })
    .then(() => {
      toast.success("Cliente accorpato correttamente", {
        closeButton: <CloseButton />
      })
      this.setState({
        stepAccorpamento: 1,
        clienteId: ''
      })
    })
    .catch(error => {
      console.log(error.message)
      toast.error(`È avvenuto un errore durante l'accorpamento`, {
        closeButton: <CloseButton />
      })
    })
  }


  render() {
    const { cliente, canDeleteCustomer, isAgente, utenteId } = this.props
    const { azioni } = cliente

    const forms = azioni.filter(azione => azione.tipoAzione.tipo.toLowerCase() === 'form')

    let provenienza = ''
    let primaRichiesta = ''

    if (forms.length > 0) {
      const primoForm = forms[forms.length - 1] // ordine data DESC => l'ultimo form è il primo arrivato
      provenienza = primoForm.campagna ? primoForm.campagna.nome : ''
      primaRichiesta = primoForm.offerta ? primoForm.offerta.nome : ''
    }

    return (
      <div className="dati">
        <GridContainer justify="space-around" alignItems="baseline" direction="row">
          <ItemGrid xs={11} md={6}>
            <FormCliente cliente={cliente} onSaved={this.handleSaved} isAgente={isAgente} utenteId={utenteId} />
          </ItemGrid>
          <ItemGrid xs={11} md={5} lg={4}>
            <table className="additional-info">
              <tbody>
                <tr>
                  <td>Data creazione:</td>
                  <td>{moment(cliente.dataCreazione).format('DD/MM/YYYY')}</td>
                </tr>
                <tr>
                  <td>Prima richiesta:</td>
                  <td>{primaRichiesta}</td>
                </tr>
                <tr>
                  <td>Portale:</td>
                  <td>
                    <PortalIndicators portals={getPortalsFromInterests(cliente.interessi)} />
                  </td>
                </tr>
                <tr>
                  <td>Provenienza:</td>
                  <td>{provenienza}</td>
                </tr>
                <tr>
                  <td>Ultima richiesta:</td>
                  <td>{cliente.dataUltimaRichiesta ? moment(cliente.dataUltimaRichiesta).format('DD/MM/YYYY') : 'Nessuna richiesta'}</td>
                </tr>
                <tr>
                  <td>Ultimo contatto:</td>
                  <td>{cliente.dataUltimoContatto ? moment(cliente.dataUltimoContatto).format('DD/MM/YYYY') : ''}</td>
                </tr>
                <tr>
                  <td>
                    <Button style={{ marginTop: 20 }} variant="raised" color="primary" onClick={this.openSendAlert}>Invia ad affitti &raquo;</Button>
                  </td>
                </tr>
                {!!canDeleteCustomer &&
                  <tr>
                    <td colSpan="2">
                      <Button style={{ marginTop: 20 }} className="delete-button" type="button" variant="raised" color="secondary" onClick={this.openDeleteAlert}>Elimina cliente</Button>
                      
                      <div className="accorpamento">
                        {this.state.stepAccorpamento !== 2 ?
                          <div className="primo-step">
                            Accorpa cliente con codice:&nbsp;
                            <TextField value={this.state.clienteId} onChange={this.handleChangeClienteId} /><br />
                            <Button style={{ marginTop: 10 }} type="button" variant="raised" color="primary" onClick={this.handleCercaClienteDaAccorpare}>Cerca</Button>
                          </div>
                        :
                          <div className="secondo-step">
                            <Query query={clientiById} variables={{ id: parseInt(this.state.clienteId, 10) }}>
                              {({ loading, error, data }) => {
                                if (loading) return <p>Loading...</p>
                                if (error) return <p>Error :(</p>
                                return (
                                  <div>
                                    {data.clienti.nodes[0] ?
                                      <div className="trovato">
                                        Accorpare
                                        <div className="cliente-da-accorpare">
                                          <b>{data.clienti.nodes[0].nome}</b><br />
                                          {data.clienti.nodes[0].email}<br />
                                        </div>
                                        a questo cliente?<br />
                                        <Button style={{ marginTop: 10 }} type="button" variant="raised" color="primary" onClick={this.handleConfermaAccorpamento(cliente.id, data.clienti.nodes[0].id)}>Conferma accorpamento</Button>
                                      </div>
                                    :
                                      <div className="non-trovato">
                                        Codice non trovato<br />
                                        <Button style={{ marginTop: 10 }} type="button" variant="raised" color="primary" onClick={this.handleRiprovaAccorpamento}>Riprova</Button>
                                      </div>
                                    }
                                  </div>
                                )
                              }}
                            </Query>
                          </div>
                        }
                      </div>

                    </td>
                  </tr>
                }
              </tbody>
            </table>

            <FormCreaAzione clienteId={cliente.id} onSaved={this.handleActionCreated} />

            {/* <DropzoneAllegato title={'Allegato 1'} onSaved={this.handleFileSaved} />
            <DropzoneAllegato title={'Allegato 2'} onSaved={this.handleFileSaved} />
            <DropzoneAllegato title={'Allegato 3'} onSaved={this.handleFileSaved} /> */}
          </ItemGrid>
        </GridContainer>
        
        <SweetAlert
          show={!!this.state.showDeleteAlert} 
          type="warning"
          title="Conferma eliminazione"
          html={true}
          text={`<h4>Sei sicuro di voler eliminare "${cliente.nome}"? <br /><span style="color: #ef5350">Questa azione è irreversibile.</span></h4>`}
          showCancelButton={true}
          confirmButtonText="Sì, elimina cliente"
          confirmButtonColor="#ef5350"
          cancelButtonText="Annulla"
          onConfirm={this.handleDeleted(cliente.id, cliente.nome)}
          onCancel={this.closeDeleteAlert}
        />

        <SweetAlert
          show={!!this.state.showSendAlert} 
          type="warning"
          title="Conferma invio"
          html={true}
          text={`<h4>Sei sicuro di voler inviare ad affittimoderni.it "${cliente.nome}"? <br /><span style="color: #ef5350">Questa azione è irreversibile.</span></h4>`}
          showCancelButton={true}
          confirmButtonText="Sì, invia ad affitti"
          confirmButtonColor="#4cae4e"
          cancelButtonText="Annulla"
          onConfirm={this.handleSent(cliente.id, cliente.nome)}
          onCancel={this.closeSendAlert}
        />
      </div>
    )
  }
}

export default compose (
  graphql(deleteCliente, { name: 'deleteCliente' }),
  graphql(accorpaClienti, { name: 'accorpaClienti' }),
  graphql(inviaAdAffitti, { name: 'inviaAdAffitti' })
)(Dati)



// WEBPACK FOOTER //
// ./src/views/App/Clienti/Dati.jsx